import { makeStyles, tokens } from '@fluentui/react-components';

export const useHelpPageStyles = makeStyles({
  page: {
    maxWidth: '1100px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  tabContent: {
    marginTop: '20px',
  },
  card: {
    padding: '24px',
  },
  accordion: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  accordionItem: {
    backgroundColor: tokens.colorNeutralBackground2,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
    overflow: 'hidden',
  },
  accordionPanel: {
    paddingRight: '16px',
    paddingBottom: '16px',
    color: tokens.colorNeutralForeground2,
  },
  supportBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
  },
  supportHeading: {
    margin: 0,
  },
});
